import { Tab, Nav } from 'react-bootstrap';
import ProfilTab from '../../components/Tabs/ProfilTabs/ProfilTab';
import SecurityTab from '../../components/Tabs/ProfilTabs/SecurityTab';
import NotificationsTab from '../../components/Tabs/ProfilTabs/NotificationsTab';
import PreferencesTab from '../../components/Tabs/ProfilTabs/PreferencesTab';



const Profil = ({ titre }) => {
    return (
        <>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">{titre}</h1>
            </div>

            <div className="mt-3 px-4">
                <Tab.Container defaultActiveKey="profil">
                    <Nav variant="tabs">
                        <Nav.Item>
                            <Nav.Link eventKey="profil">Profil</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="securite">Sécurité</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="preferences">Préférences</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="notifications">Notifications</Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <Tab.Content className="mt-4">
                        <Tab.Pane eventKey="profil">
                            <ProfilTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="securite">
                            <SecurityTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="preferences">
                            <PreferencesTab />
                        </Tab.Pane>
                        <Tab.Pane eventKey="notifications">
                            <NotificationsTab />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div>
        </>
    );
};

export default Profil;
